module.exports = __webpack_public_path__ + "img/invShoreOfflineFlow.gif.326ba56a.jpg";